import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './presentation/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore, { DataImplementation } from './presentation/redux/store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const store = configureStore(DataImplementation.MOCK);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
